    import { useState, useEffect } from "react";
    import { API_BASE_URL } from "../config/config"; 
    import { useNavigate } from "react-router-dom";

    const Passports = () => {
        const navigate = useNavigate();
        
        const [countries, setCountries] = useState([]);
        const [document, setDocument] = useState({});
        const [documentOptions, setDocumentOptions] = useState([]);

        const deliveryMethods = ["WhatsApp", "Telegram", "Jabber", "E-mail"];

        const [selectCountry, setSelectCountry] = useState('');
        const [selectOption, setSelectOption] = useState('');
        const [selectPrice, setSelectPrice] = useState(0);
        const [selectDeliveryMethod, setSelectDeliveryMethod] = useState('');

        // Logic for different country categories
        const isUSCustom = selectCountry === "United States (Custom Requests)";
        const isAnyOther = selectCountry === "Any Other Country";
        const isCustomInformation = selectCountry === "Custom Made Bank Statements";
        const isNormalCountry = selectCountry && !isUSCustom && !isAnyOther && !isCustomInformation;




        useEffect(() => {
            // document ki jagah window.document use karein
            const inputs = window.document.querySelectorAll('input[required], select[required]');
            
            inputs.forEach(input => {
                input.oninvalid = (e) => {
                    e.target.setCustomValidity("Complete this section.");
                };
                input.oninput = (e) => {
                    e.target.setCustomValidity("");
                };
            });
        }, [selectDeliveryMethod, documentOptions]);





        const getData = async () => {
            let slug = "other-accounts";
            try {
                const response = await fetch(`${API_BASE_URL}/get-options?slug=${slug}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" }
                });
                const result = await response.json();
                if (result.success == 1) {
                    setCountries(result.countries);
                    setDocument(result.documents[0] || {});
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }

        // Dynamic handleForm: Yeh sab inputs ko pakad lega
        const handleForm = (e) => {
            e.preventDefault();

            const formData = new FormData(e.target);
            const formEntries = Object.fromEntries(formData.entries());
            
            // Data packaging
            const allOrderData = {
                ...formEntries, // Isme name, dob, address sab automatically aa jayenge
                select_country: selectCountry,
                select_document_type: selectOption,
                price: selectPrice,
                delivery_method: selectDeliveryMethod,
                service_type: "Passport",
                category_slug: "passports"
            };

            // Checkout redirect
            navigate(`/checkout?price=${selectPrice}&plan=${encodeURIComponent(selectOption)}`, {
                state: { orderData: allOrderData }
            });
        };

        useEffect(() => {
            getData();
        }, [])

        return (
            <div className="passport-container">
                <div className="product-main">
                    <div className="product-image-box">
                        <div className="placeholder-img">
                            <img src={document.image_path || ''} alt={document.title || 'Passport Service'} />
                        </div>
                    </div>

                    <div className="product-info">
                        <h2 className="prod-title">{document.title || "Other Accounts (Self Registered Accounts)"}</h2>

                        {/* 1. SELECT COUNTRY */}
                        <div className="field-group">
                            <label>Select Account Type</label>
                            <select
                                required
                                onChange={(e) => {
                                    const countryId = e.target.value;
                                    const selectedCountry = countries.find(c => c.id == countryId);
                                    if (selectedCountry) {
                                        setSelectCountry(selectedCountry.name);
                                        setDocumentOptions(selectedCountry.document_options);
                                    } else {
                                        setSelectCountry('');
                                        setDocumentOptions([]);
                                    }
                                }}
                            >
                                <option value="">Choose...</option>
                                {countries.map((country, index) => (
                                    <option key={index} value={country.id}>{country.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* 2. SELECT DOCUMENT TYPE */}
                        {documentOptions.length > 0 && (
                            <div className="field-group">
                                <label>Select Subscription Type</label>
                                <select
                                    required
                                    onChange={(e) => {
                                        const optionId = e.target.value;
                                        const selected = documentOptions.find(opt => opt.id == optionId);
                                        if (selected) {
                                            setSelectOption(selected.title);
                                            setSelectPrice(selected.price);
                                        }
                                    }}
                                >
                                    <option value="">Choose Document Type...</option>
                                    {documentOptions.map((option, index) => (
                                        <option key={index} value={option.id}>{option.title} ${option.price}</option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* PRICE DISPLAY */}
                        {selectPrice > 0 && (
                            <div className="total-price-box" style={{
                                margin: '15px 0', padding: '12px',
                                backgroundColor: '#f8f9fa', borderLeft: '4px solid #000', fontSize: '18px'
                            }}>
                                <strong>Total Price: ${selectPrice}</strong>
                            </div>
                        )}

                        {/* 3. DELIVERY METHOD */}
                        {selectPrice > 0 && (
                            <div className="field-group">
                                <label>Delivery Method</label>
                                <select required onChange={(e) => setSelectDeliveryMethod(e.target.value)}>
                                    <option value="">Choose...</option>
                                    {deliveryMethods.map((m) => <option key={m} value={m}>{m}</option>)}
                                </select>
                            </div>
                        )}

                        {/* 4. DYNAMIC FORM */}
                        {selectDeliveryMethod && (
                            <form className="order-details-box modern-card" onSubmit={handleForm}>
                                <h3>Order Details</h3>
                                <div className="input-grid">
                                    <input
                                        name="delivery_handle"
                                        required
                                        placeholder={`Enter your ${selectDeliveryMethod} for delivery`}
                                        className="full-width"
                                    />

                                    {isNormalCountry && (
                                            <textarea
                                                name="instructions"
                                                placeholder="Extra Instructions (Optional)"
                                                className="full-width"
                                            />
                                        )}

                                        {isAnyOther && (
                                            <>
                                                <input
                                                    name="country"
                                                    required
                                                    placeholder="Specify Country"
                                                />

                                                <input
                                                    name="city"
                                                    placeholder="Specify City / State (Optional)"
                                                />

                                                <input
                                                    name="gender"
                                                    placeholder="Specify Gender (Optional)"
                                                />

                                                <input
                                                    name="age"
                                                    placeholder="Specify Age (Optional)"
                                                />

                                                <textarea
                                                    name="instructions"
                                                    placeholder="Extra Instructions (Optional)"
                                                    className="full-width"
                                                />
                                            </>
                                        )}

                                        {isUSCustom && (
                                            <>
                                                <input
                                                    name="credit_score"
                                                    placeholder="Specify Credit Score (Optional)"
                                                />

                                                <input
                                                    name="city"
                                                    placeholder="Specify City/State (Optional)"
                                                />

                                                <input
                                                    name="gender"
                                                    placeholder="Specify Gender (Optional)"
                                                />

                                                <input
                                                    name="age"
                                                    placeholder="Specify Age (Optional)"
                                                />

                                                <textarea
                                                    name="instructions"
                                                    placeholder="Extra Instructions (Optional)"
                                                    className="full-width"
                                                />
                                            </>
                                        )}

                                        {isCustomInformation && (
                                            <>
                                                <input
                                                    name="passport_number"
                                                    placeholder="Passport Number (Optional)"
                                                />

                                                <input
                                                    name="passport_issue_expiry_date"
                                                    placeholder="Passport Issue/Expiry Dates (Optional)"
                                                />

                                                <input
                                                    name="full_name"
                                                    required
                                                    placeholder="Full Name"
                                                />

                                                <input
                                                    name="date_of_birth"
                                                    required
                                                    placeholder="Date Of Birth"
                                                />

                                                <input
                                                    name="country"
                                                    required
                                                    placeholder="Specify Country"
                                                />

                                                <input
                                                    name="address"
                                                    placeholder="Full Address (Optional)"
                                                />

                                                <input
                                                    name="gender"
                                                    required
                                                    placeholder="Specify Gender"
                                                />

                                                <input
                                                    name="custom_signature"
                                                    placeholder="Custom Signature (Optional)"
                                                />

                                                <textarea
                                                    name="instructions"
                                                    placeholder="Extra Instructions (Optional)"
                                                    className="full-width"
                                                />
                                            </>
                                        )}
                                </div>
                                <button type="submit" className="buy-btn">PROCEED TO CHECKOUT</button>
                            </form>
                        )}
                    </div>
                </div>

                <div className="product-description">
                    <h4 className="mt-4">Product Details</h4>
                    <div dangerouslySetInnerHTML={{ __html: document.content || '' }}></div>
                </div>
            </div>
        );
    }

    export default Passports;